import { ref, computed } from 'vue'

export interface PhotoSubjects {
  male: number
  female: number
  boy: number
  girl: number
  senior_male: number
  senior_female: number
}

const defaultSubjects: PhotoSubjects = {
  male: 0,
  female: 0,
  boy: 0,
  girl: 0,
  senior_male: 0,
  senior_female: 0
}

const subjects = ref<PhotoSubjects>({ ...defaultSubjects })

function updateSubject(key: keyof PhotoSubjects, value: number) {
  subjects.value[key] = Math.max(0, Math.min(10, Math.floor(value) || 0))
}

function reset() {
  subjects.value = { ...defaultSubjects }
}

const hasAnySubject = computed(() =>
  Object.values(subjects.value).some(v => v > 0)
)

function toPayload(): PhotoSubjects | null {
  if (!hasAnySubject.value) return null
  return { ...subjects.value }
}

export function usePhotoSubjects() {
  return {
    subjects,
    updateSubject,
    reset,
    hasAnySubject,
    toPayload
  }
}
